import { CardProps, ThemeConfig } from 'antd';
import { DrawerStyles } from 'antd/es/drawer/DrawerPanel';
import { BASE_RED, BASE_WARNING_YELLOW, BASE_WHITE, GRAY_BLUE, OLIVE_GREEN, TURQUOISE_DARK_GREEN } from '../scss/_colors';

export const classicTheme: ThemeConfig = {
  token: {
    colorPrimary: GRAY_BLUE,
    colorPrimaryHover: TURQUOISE_DARK_GREEN,
    colorError: BASE_RED,
    colorLink: GRAY_BLUE,
    colorWhite: BASE_WHITE,
  },
  components: {
    Alert: {
      colorSuccessBg: OLIVE_GREEN,
      colorSuccess: TURQUOISE_DARK_GREEN,
      colorSuccessBorder: TURQUOISE_DARK_GREEN,
    },
    Button: {
      colorPrimaryActive: GRAY_BLUE,
      colorPrimary: GRAY_BLUE,
    },
    Carousel: {
      colorBgContainer: OLIVE_GREEN,
    },
    Card: {
      colorTextHeading: GRAY_BLUE,
    },
    Collapse: {
      colorTextHeading: GRAY_BLUE,
    },
    Result: {
      colorWarning: BASE_WARNING_YELLOW,
    },
    Drawer: {
      colorBgTextActive: TURQUOISE_DARK_GREEN,
      colorBgTextHover: GRAY_BLUE,
      colorIconHover: BASE_WHITE,
      colorIcon: BASE_WHITE,
      colorText: BASE_WHITE,
    },
    Form: {},
    Input: {
      colorPrimary: GRAY_BLUE,
    },
    List: {},
    Rate: {
      fontSize: 20,
    },
    Slider: {
      handleActiveColor: GRAY_BLUE,
      handleColor: GRAY_BLUE,
      trackHoverBg: TURQUOISE_DARK_GREEN,
      trackBg: GRAY_BLUE,
      colorPrimaryBorderHover: GRAY_BLUE,
    },
    Spin: {
      colorPrimary: TURQUOISE_DARK_GREEN,
    },
    Tabs: {
      inkBarColor: GRAY_BLUE,
      itemActiveColor: GRAY_BLUE,
      itemSelectedColor: GRAY_BLUE,
      titleFontSize: 16,
    },
    Tag: {},
    Tooltip: {
      colorBgSpotlight: BASE_WHITE,
      colorTextLightSolid: GRAY_BLUE,
    },
  },
};

export const drawerStyles: DrawerStyles = {
  header: {
    backgroundColor: GRAY_BLUE,
  },
};

export const productCardExtraStyles: CardProps['styles'] = {
  header: {},
  body: {
    borderRadius: 0,
  },
  extra: {},
  title: {},
  actions: {},
  cover: {},
};

export const totalProductCardExtraStyles: CardProps['styles'] = {
  body: {
    backgroundColor: GRAY_BLUE,
    color: BASE_WHITE,
    borderRadius: 8,
    textAlign: 'center',
    fontSize: 16,
  },
};
